/* ==========================================================================
   Feature signoff / benefits — entrance animation (fade-up)
   Content fades in first, images stagger after (delays handled in CSS).
   Gated on data-fsb-ready so content is visible without JS. Honors
   prefers-reduced-motion and the Shopify theme editor. Loaded once.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__featureSignoffBenefitsInit) return;
  window.__featureSignoffBenefitsInit = true;

  var forEach = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var els = root.querySelectorAll('.feature-signoff-benefits--animate:not([data-fsb-ready])');
    if (!els.length) return;

    if (REDUCE || !('IntersectionObserver' in window)) {
      forEach(els, function (el) { el.setAttribute('data-fsb-ready', ''); el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries, obs) {
      forEach(entries, function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -10% 0px' });

    forEach(els, function (el) { el.setAttribute('data-fsb-ready', ''); io.observe(el); });
  }

  function boot() { init(document); }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();
